import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// LeadConnector (HighLevel) chat widget config
const SCRIPT_ID = 'lc-chat-widget-loader';
const WIDGET_ID = '6a9da88586066d429f54ac1f';

const removeWidgetElements = () => {
    // The loader injects a <chat-widget> custom element into <body>
    document.querySelectorAll('chat-widget').forEach((n) => n.remove());
};

/**
 * Ensures the HighLevel Chat Widget (the site's A2P SMS opt-in mechanism) is
 * present on every page EXCEPT the dedicated /estimate page, where HighLevel's
 * A2P 10DLC compliance requires it to be the ONLY opt-in source on the page.
 * Because /estimate collects a phone number for estimate follow-up, the widget
 * must not be present there.
 */
export const ChatWidgetController = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const isEstimate = pathname.startsWith('/estimate');

        if (isEstimate) {
            // Remove the loader script and any injected widget elements, and keep
            // removing anything the loader tries to re-inject while on this page.
            document.getElementById(SCRIPT_ID)?.remove();
            removeWidgetElements();
            const observer = new MutationObserver(() => removeWidgetElements());
            observer.observe(document.documentElement, { childList: true, subtree: true });
            // Belt-and-suspenders: sweep a few times in case the widget boots asynchronously.
            const sweeps = [100, 400, 900, 1800, 3000].map((ms) => setTimeout(removeWidgetElements, ms));
            return () => {
                observer.disconnect();
                sweeps.forEach(clearTimeout);
            };
        }

        // Non-estimate route: inject the loader once so the widget boots.
        if (!document.getElementById(SCRIPT_ID)) {
            const s = document.createElement('script');
            s.id = SCRIPT_ID;
            s.src = 'https://widgets.leadconnectorhq.com/loader.js';
            s.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
            s.setAttribute('data-widget-id', WIDGET_ID);
            document.body.appendChild(s);
        }
    }, [pathname]);

    return null;
};
